import { useSelector } from 'react-redux';

import { type RootState } from '#apps/client-web/app/store/store';

export const useAppSelector = useSelector.withTypes<RootState>();
